import { motion, useReducedMotion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];
const VIEWPORT = { once: true, margin: "-8% 0px" };

// Soft fade-up on enter.
export function Reveal({ children, delay = 0, y = 36, className = "", ...rest }) {
  const reduce = useReducedMotion();
  return (
    <motion.div
      initial={reduce ? false : { opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={VIEWPORT}
      transition={{ duration: 1.2, ease: EASE, delay }}
      className={className}
      {...rest}
    >
      {children}
    </motion.div>
  );
}

// Masked line-by-line headline reveal (each line slides up from behind a clip).
// The clip wrapper owns the viewport trigger (the clipped inner span would never "intersect").
export function LineReveal({ lines, as: Tag = "h2", className = "", delay = 0, stagger = 0.14, ...rest }) {
  const reduce = useReducedMotion();
  return (
    <Tag className={className} {...rest}>
      {lines.map((line, i) => (
        <motion.span
          key={i}
          className="block overflow-hidden pb-[0.1em] -mb-[0.1em]"
          initial={reduce ? false : "hidden"}
          whileInView="visible"
          viewport={VIEWPORT}
        >
          <motion.span
            className="block"
            variants={{
              hidden: { y: "115%" },
              visible: { y: "0%", transition: { duration: 1.35, ease: EASE, delay: delay + i * stagger } },
            }}
          >
            {line}
          </motion.span>
        </motion.span>
      ))}
    </Tag>
  );
}
